export const noPreviewImage ="/assets/images/NoPreview.jpg"
export const badgesImage ="/assets/images/badges.png"
export const datascienceImage ="/assets/images/datascience.png"
export const architectImage ="/assets/images/architect.png"
export const engineerImage ="/assets/images/engineer.png"
export const iconClick = "/assets/images/clickeach.svg"
export const avatar =  {
  super: "/assets/icons/admin.png",
  user: "/assets/icons/avatar.svg",
  default: "/assets/icons/avatar.svg",
};